import { FC } from 'react'

import { ScreenSize } from '@/app/constants'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { PASS_REQUEST_TYPE } from '@/components/entities/requests/model/constants'
import { AppButton } from '@/components/shared/button'
import { ButtonSizes } from '@/components/shared/button/ui/Button.types'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

type Props = {
  className?: string
  size?: ButtonSizes
}

const CreatePassButton: FC<Props> = ({ className, size }) => {
  const { reachGoal } = useYandexMetrika()
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)
  const isTabletScreen = [ScreenSize.Lg, ScreenSize.Md].includes(breakpoint)
  const { navigateToAvailablePasses } = useRequestNavigation()

  const handleCreatePass = () => {
    navigateToAvailablePasses()
    reachGoal(YandexMetrikaEvent.PASSES_CREATE)
  }

  return (
    <AppButton
      className={className}
      type="button"
      variant="primary"
      size={size ?? (isMobileScreen || isTabletScreen ? 'small' : 'large')}
      data-testid="create-pass-button-id"
      onClick={handleCreatePass}
    >
      {PASS_REQUEST_TYPE.name}
    </AppButton>
  )
}

export { CreatePassButton }
